<template>
  <k-dialog>
    <div class="dialog-effect-wrapper">
      <img :src="img" />
    </div>
  </k-dialog>
</template>
<script>
import KDialog from '@com/base/Dialog';
export default {
  name: 'AnswerEffect',
  props: {
    img: {
      type: String,
      default: () => ''
    }
  },
  components: {
    KDialog
  }
};
</script>
<style lang="scss" scoped>
.dialog-effect-wrapper {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  z-index: 501;
  img {
    display: block;
    width: 460px;
  }
}
.y-rotate {
  animation: yrote 2s infinite linear;
}
</style>
<style>
@keyframes yrote {
  0% {
    transform: rotateY(0);
  }

  100% {
    transform: rotateY(360deg);
  }
}
</style>
